if (typeof window.imbrox !== 'undefined' 
    && typeof window.imbrox.productInfo !== 'undefined' 
    && typeof window.imbrox.productInfo.productType !== 'undefined'
    && typeof window.imbrox.productInfo.productType != null
    && typeof window.imbrox.productInfo.productType != ''
    && typeof window.imbrox.shopInfo !== 'undefined' 
    && typeof window.imbrox.shopInfo.shopUrl !== 'undefined'
    && typeof window.imbrox.shopInfo.shopUrl != null
    && typeof window.imbrox.shopInfo.shopUrl != ''
   ) {
   
  var currentProductMetafileds = window.imbrox.productInfo.productFilterMetafields;
  var tmpProductsList = [];
  //var dropdownListObject = {};
  
  if(currentProductMetafileds != ''){
    var dropdownListObject = [];
    jQuery.each(currentProductMetafileds, function( key, value ) {
      if(value != ''){
          dropdownListObject.push({
            tagKey:key,
            tagLabel:key.substr(0,1).toUpperCase() + key.substr(1)
          });
      }
    });
  }

  var productType = window.imbrox.productInfo.productType;
  var productPrice = window.imbrox.productInfo.productPrice;
  var shopInfo = window.imbrox.shopInfo;
  var shopUrl = shopInfo.shopUrl;
  const ACCESS_TOKEN = '7c95710ffc54f14dcf114133b135c1f7';
  const GRAPHQL_URL = shopUrl+'/api/2022-01/graphql.json';
  
  let mutation = `
         {
          products(first: 250, query: "product_type:'`+productType+`'") {
            edges {
              node {
                title
                productType
                onlineStoreUrl
                tags
              }
            }
          }
        }
      `;
  
 
  var xhr = new XMLHttpRequest();
  xhr.open("POST", GRAPHQL_URL);
  xhr.setRequestHeader("Content-Type", "application/graphql");
  xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
  xhr.setRequestHeader("X-Shopify-Storefront-Access-Token", ACCESS_TOKEN);

  xhr.onreadystatechange = function () {
     if (xhr.readyState === 4) {
        initResponseData(xhr);
     }
  };
  var data = mutation;
  
  xhr.send(data);
}

var initResponseData = function(xhr){
  if (xhr.status == 200 && typeof xhr !== 'undefined' && typeof xhr.response !== 'undefined') {
    var responseObject = JSON.parse(xhr.response);
     if (typeof responseObject !== 'undefined' 
        && typeof responseObject.data !== 'undefined' 
        && typeof responseObject.data !== 'undefined'
        && typeof responseObject.data.products !== undefined
        && typeof responseObject.data.products.edges !== undefined
        && responseObject.data.products.edges != null
       ) {

       var responseObjectProducts = responseObject.data.products.edges;
       
       var exactMatchProducts = responseObjectProducts.filter(product => {
         return product.node.productType === productType; // Exact match check
       });
       
       jQuery.each(exactMatchProducts, function( key, value ) { // Process Items
        var tmpProduct = {};
        if (typeof value.node !== 'undefined' && value.node != null){
          var responseObjectProductsProp = value.node;
          jQuery.each(responseObjectProductsProp, function( propKey, propValue ) { // Process Items Properties
            
            if (typeof propValue == 'object' && propKey == 'tags'){
              var itemtags = propValue;
              if (typeof itemtags !== 'undefined' && itemtags != null){
                jQuery.each(itemtags, function( tag_key, tag_val ) { // Process Items Metafields
                  jQuery.each(currentProductMetafileds, function( key, value ) {
                    if(key != ''){
                      if(tag_val.includes(key+'-')){
                        var metaField = tag_val.split(key+'-');
                        var metaField = metaField[metaField.length-1];
                        tmpProduct[key] = metaField.trim();
                      }
                    }
                  });
                });
              }
            }
            else{
              tmpProduct[propKey] = propValue;
            }
          })
        }
        tmpProductsList.push(tmpProduct);
      });
       
     }
  }
  processSimilarItemsDropdown();
}

var processSimilarItemsDropdown = function(){
  if (typeof tmpProductsList !== 'undefined' && typeof dropdownListObject !== 'undefined' && dropdownListObject != null && dropdownListObject.length > 0) {
    var incrementalFlag = 0;
    //process Only first Element
    var firstDropdownobj = dropdownListObject[0];
    var tagKey = firstDropdownobj.tagKey;
    var tagLabel = firstDropdownobj.tagLabel;
    var currentKeyValue = currentProductMetafileds[tagKey];
    onChangeRenderDropdowns(tmpProductsList, tagKey, tagLabel, true, false,"",1+"_"+tagKey);
    onChangeInitProductList(tagKey, currentKeyValue, false, false, false);
  }
}

var prodListBasedOnSelection = function(productList, tag_key, tagValue){

  // console.log(productList)
  
  var filteredProductList = [];
  if (typeof productList !== 'undefined' && productList != null) {
    // Extract dropdown values from the products list
    jQuery.each(productList, function( key, value ) {
      if(value[tag_key] == tagValue){
      	filteredProductList.push(value);
      }
    })
  }
  return filteredProductList;
}

var cushionCount = window.imbrox.cushionInfo.cushionCount;
var sizePopup = window.imbrox.sizeInfo.sizePopup;
var sizePopupTitle = window.imbrox.sizeInfo.sizePopupTitle;



var onChangeInitProductList = function(currentSelectbox, selectedValue, userSelection, is_click, is_last, is_empty){
  setTimeout(function() {
    var first_obj = dropdownListObject[0].tagKey;
    var selectSizevalue = jQuery('.var_dropdown li[data-title="'+first_obj+'"] ul li.active').data('val');
    var selectFoamvalue = jQuery('.var_dropdown li[data-title="foam-comfort"] ul li.active').data('val');
    
    preSelectvalue(selectSizevalue,selectFoamvalue, currentSelectbox);
  }, 800);

  var dropdownValues = [];
  var tmpProductsFilteredList = null;
  var lastOptionDropdown = null;
  var selectboxvalue = null;
  var generateNextHtml = false;
  var preselect = false;
  
  jQuery.each(dropdownListObject, function(key, value, index) {
    if(tmpProductsFilteredList == null){
      tmpProductsFilteredList = tmpProductsList;
    }
    
    var selectboxvalue = jQuery('.var_dropdown li[data-title="'+value.tagKey+'"] ul li.active').data('val');

    if(value.tagKey == "size"){
      if(sizePopup == true){
        jQuery('.var_dropdown li[data-title="'+value.tagKey+'"]').find(".sel-val").html("<a href='javascript:void(0)' class='popup-sofasize'>"+sizePopupTitle+"</a>");
      }
    }
    else if(value.tagKey == "cushion-type"){
      if(typeof selectboxvalue != 'undefined') {
        jQuery('.var_dropdown li[data-title="'+value.tagKey+'"]').find(".sel-val").html(" - "+selectboxvalue);
      }
      if(typeof cushionCount != 'undefined' && cushionCount != "") {
        jQuery('.var_dropdown li[data-title="'+value.tagKey+'"]').find(".cus_count").html("("+cushionCount+")");
      }
    }
    else if(value.tagKey == "color" || value.tagKey == "fabric-type") {
      if(typeof selectboxvalue != 'undefined') { 
        jQuery('.var_dropdown li[data-title="'+value.tagKey+'"]').find(".prod-type").html(" - "+productType);
        jQuery('.var_dropdown li[data-title="'+value.tagKey+'"]').find(".sel-val").html(" / "+selectboxvalue);
        
      }
    }
    else if(value.tagKey == "finish" ) {
      if(typeof selectboxvalue != 'undefined') { 
        // jQuery('.var_dropdown li[data-title="'+value.tagKey+'"]').find(".prod-type").html(" - "+productType);
        jQuery('.var_dropdown li[data-title="'+value.tagKey+'"]').find(".sel-val").html(" - "+selectboxvalue);
        
      }
    }
    
    if(selectboxvalue == currentProductMetafileds[value.tagKey]){
      preselect = true;
    }
    
    tmpProductsFilteredList = prodListBasedOnSelection(tmpProductsFilteredList, value.tagKey, selectboxvalue);
    
    if(currentSelectbox == value.tagKey){
      generateNextHtml = true;
    }
    
    if(generateNextHtml == true){
      var index = dropdownListObject.indexOf(value);
      if(index >= 0 && index < dropdownListObject.length - 1){
        var nextElement = dropdownListObject[index + 1];
        var tagKey = nextElement.tagKey;
        var tagLabel = nextElement.tagLabel;
        onChangeRenderDropdowns(tmpProductsFilteredList, tagKey, tagLabel, preselect, is_click, is_empty,index+2+"_"+tagKey);
      }
    }
    
    //Check if User change last selectbox
    var dropdownListObjLength = dropdownListObject.length;
    var lastDropdownListObj = dropdownListObject[dropdownListObjLength-1];
    
    if(userSelection == true && currentSelectbox == value.tagKey && lastDropdownListObj.tagKey == currentSelectbox){
      // console.log('REDIRECT !!!!');
      
      /*if(tmpProductsFilteredList.length == 1){*/
      if(is_last){
        var redirect_url = tmpProductsFilteredList[0]['onlineStoreUrl'];
        window.location.href = redirect_url;
      }else{
        console.log(tmpProductsFilteredList);
      }
    }
  });
}

var SizeInfo = window.imbrox.sizeInfo.sofaSize;
var fabricInfo = window.imbrox.fabricInfo.fabricColor;
var cushionInfo = window.imbrox.cushionInfo.cushionColor;

var onChangeRenderDropdowns = function(productsList, tagKey, tagLabel, preselect, is_click, is_empty,key_name){
  dropdownValues = [];
  var selectedAttr = '';
  
  if (typeof productsList !== 'undefined' && productsList != null) {
    // Extract dropdown values from the products list
    //console.log('productsList', productsList)
    jQuery.each(productsList, function( key, value ) {
      if(typeof value[tagKey] !== 'undefined'){
        var option = value[tagKey].trim();
        dropdownValues.push(option);
      }
    });
    
    var dropdownUniqueValues = dropdownValues.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    });
  }
  
  if (typeof dropdownUniqueValues !== 'undefined' && dropdownUniqueValues != null) {
    // Extract dropdown values from the products list
    dropdownUniqueValues.sort();
    
    if(preselect == true && is_click == false){
      var optionsHtml = '';
    }
    else{
      var optionsHtml = '<li class="active select_opt" style="display:none"><a>Select '+tagLabel.replace("-", " ")+'</a></li>';
    }
    
    jQuery.each(dropdownUniqueValues, function( key, value ) {
      //Check if preselect value
      var selectedAttr = '';
      if(preselect == true && value == currentProductMetafileds[tagKey] && is_click == false){
        var selectedAttr = 'class="active"';
      }
      var final_val = value.replace(/^(.)|\s(.)/g, function($1){ return $1.toUpperCase( ); });

      if(tagKey == "size"){
        var has_size = false;
        
        jQuery.each(SizeInfo, function( s_key, s_value ) {
          if(value.toLowerCase() == Object.keys(s_value)[0].toLowerCase()){
            var size_arr = Object.values(s_value)[0].split('-');
            var high_text="";
            
            if(size_arr[1] == "true" && size_arr[2] != ""){
              var high_text = "<span class='highlight_tag'>"+size_arr[2]+"</span>"
            }
            optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1">'+high_text+'<a><span>'+size_arr[0]+'</span>'+final_val+'</a></li>';
            has_size = true;
          }
        });
        if(has_size == false){
          optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a>'+final_val+'</a></li>';
        }
        
      }
      else if (tagKey == "color" || tagKey == "fabric-type") {
        var has_img = false;
               
        jQuery.each(fabricInfo, function( s_key, s_value ) {
          if(value.toLowerCase() == Object.keys(s_value)[0].toLowerCase()){
            if(Object.values(s_value)[0].indexOf("no-image") != -1){
              optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/no-image.png?v=1732192306"></span></a></li>';
            }
            else{
              optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="'+Object.values(s_value)[0]+'" title="'+value+'"></span></a><div class="img-hover"><img src="'+Object.values(s_value)[0]+'" title="'+value+'"></div></li>';
            }
            has_img = true;
          }
        });

        if(has_img == false){
          optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/no-image.png?v=1732192306"></span></a></li>';
        }
      } 
      else if(tagKey == "cushion-type") {
        var has_img = false;
        
        jQuery.each(cushionInfo, function( s_key, s_value ) {
          if(value.toLowerCase() == Object.keys(s_value)[0].toLowerCase()){
            if(Object.values(s_value)[0].indexOf("no-image") != -1){
              optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/no-image.png?v=1732192306"></span></a></li>';
            }
            else{
              optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="'+Object.values(s_value)[0]+'" title="'+value+'"></span></a><div class="img-hover"><img src="'+Object.values(s_value)[0]+'" title="'+value+'"></div></li>';
            }
            has_img = true;
          }
        });
        
        if(has_img == false){
          optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/no-image.png?v=1732192306"></span></a></li>';
        }
      }
      else if (tagKey == "finish") {
        var has_img = false;
               
        jQuery.each(fabricInfo, function( s_key, s_value ) {
          if(value.toLowerCase() == Object.keys(s_value)[0].toLowerCase()){
            if(Object.values(s_value)[0].indexOf("no-image") != -1){
              optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/no-image.png?v=1732192306"></span></a></li>';
            }
            else{
              optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="'+Object.values(s_value)[0]+'" title="'+value+'"></span></a><div class="img-hover"><img src="'+Object.values(s_value)[0]+'" title="'+value+'"></div></li>';
            }
            has_img = true;
          }
        });

        if(has_img == false){
          optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a><span><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/no-image.png?v=1732192306"></span></a></li>';
        }
      }   
      else{
        optionsHtml += '<li '+selectedAttr+' data-val="'+value+'" optionvalue="option1"><a>'+final_val+'</a></li>';
      }
    });
  }
  else{
    var optionsHtml = '<li class="not_available_cls"><a>'+tagLabel.replace("-", " ")+' not available.</a></li>';
  }
  
  var selectBox = $('.var_dropdown li[data-title="'+tagKey+'"]');
  var icon = "";
  var fabric = "";
  var prodType = "";
  
  if(tagKey == "color" || tagKey == "fabric-type") {
    icon = '<span class="type-icon"><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/color-icon.png?v=1733382338"></span>';
    fabric = "Fabric / ";
    prodType = '<span class="prod-type"> - '+productType+'</span>';
  }
  if(tagKey == "finish" ) {
    icon = '<span class="type-icon"><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/color-icon.png?v=1733382338"></span>';
    // fabric = "Fabric / ";
    // prodType = '<span class="prod-type"> - '+productType+'</span>';
  }  
  else if(tagKey == "cushion-type") {
    icon = '<span class="type-icon"><img src="https://cdn.shopify.com/s/files/1/0977/9664/files/Icon_1.png?v=1733382363"></span>';
  }
  
  var select = "";
  if(tagKey == "cushion-type" ) {
    select = "Step "+key_name.split('_')[0]+": Select Matching ";
  }
  else{
    select = "Step "+key_name.split('_')[0]+": Select ";
  }
  
  if(selectBox.length > 0){
    var selected_title = 'Select '+tagLabel.replace("-", " ");
    
    if(optionsHtml != ''){ 
      var dropdownHtml_new =  '<label>'+icon+select+"<span>"+fabric+tagLabel.replace("-", " ")+"</span>"+prodType+'<span class="sel-val"></span></label> \
        <div class="dropdown_title"><span>'+selected_title+'</span> \
		  <svg class="" width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.27276 8C7.10367 8 6.93441 7.93483 6.80532 7.80467L0.19376 1.13804C-0.0645867 0.877537 -0.0645867 0.455706 0.19376 0.195374C0.452107 -0.064958 0.870453 -0.0651247 1.12863 0.195374L7.27276 6.39068L13.4169 0.195374C13.6752 -0.0651247 14.0936 -0.0651247 14.3518 0.195374C14.6099 0.455873 14.6101 0.877703 14.3518 1.13804L7.7402 7.80467C7.6111 7.93483 7.44185 8 7.27276 8Z" fill="#464646"/></svg> \
		</div> \
        <ul class="dropdown_hide" name="option-1">'+optionsHtml+'</ul><span class="frm_error"></span>';
    }
    
    /* if last dropdown has not any options available then redirect on second dropdown click */
    if(typeof is_empty !== 'undefined' && is_empty != 0 && dropdownUniqueValues.length == 0){
      var dropdownHtml_new1 =  '<label>'+icon+tagLabel.replace("-", " ")+' <span class="cus_count"></span></label> \
        <div class="dropdown_title"><span>'+selected_title+'</span> \
          <svg class="" width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.27276 8C7.10367 8 6.93441 7.93483 6.80532 7.80467L0.19376 1.13804C-0.0645867 0.877537 -0.0645867 0.455706 0.19376 0.195374C0.452107 -0.064958 0.870453 -0.0651247 1.12863 0.195374L7.27276 6.39068L13.4169 0.195374C13.6752 -0.0651247 14.0936 -0.0651247 14.3518 0.195374C14.6099 0.455873 14.6101 0.877703 14.3518 1.13804L7.7402 7.80467C7.6111 7.93483 7.44185 8 7.27276 8Z" fill="#464646"/></svg> \
		</div> \
        <ul class="dropdown_hide" name="option-1"><li class="active not_available_cls"><a>'+tagLabel.replace("-", " ")+' not available.</a></li></ul>';
        selectBox.empty().append(dropdownHtml_new1);
    }
    else{
      selectBox.empty().append(dropdownHtml_new);
    }
    
  }
  else{
    var final_active_val = currentProductMetafileds[tagKey].replace(/^(.)|\s(.)/g, function($1){ return $1.toUpperCase( ); });
    var dropdownHtml =  '<li class="dropdown_dec p-relative '+ tagKey+'_dropdown" data-title="'+tagKey+'"> \
        <label>'+icon+select+"<span>"+fabric+tagLabel.replace("-", " ")+"</span>"+' <span class="prod-type"></span><span class="sel-val"></span><span class="cus_count"></span></label>  \
        <div class="dropdown_title"><span>'+final_active_val+'</span> \
		  <svg class="" width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.27276 8C7.10367 8 6.93441 7.93483 6.80532 7.80467L0.19376 1.13804C-0.0645867 0.877537 -0.0645867 0.455706 0.19376 0.195374C0.452107 -0.064958 0.870453 -0.0651247 1.12863 0.195374L7.27276 6.39068L13.4169 0.195374C13.6752 -0.0651247 14.0936 -0.0651247 14.3518 0.195374C14.6099 0.455873 14.6101 0.877703 14.3518 1.13804L7.7402 7.80467C7.6111 7.93483 7.44185 8 7.27276 8Z" fill="#464646"/></svg> \
		</div> \
        <ul class="dropdown_hide" name="option-1">'+optionsHtml+'</ul><span class="frm_error"></span>\
        </li>';
    jQuery('.var_dropdown').append(dropdownHtml);
  }
}

$(document).on('click', '.var_dropdown li ul li' , function(){

    var $group = $(this).closest('li.dropdown_dec');

  if ($group.is('.size_dropdown,.seats_dropdown,.sizes_dropdown')) {
    var sizeKey = $group.data('title');
    var sizeValue = $(this).data('val');

    if (typeof sizeValue === 'undefined' ||
        $(this).hasClass('not_available_cls')) return;

    var $options = $(this).closest('.var_dropdown');
    var candidates = prodListBasedOnSelection(
      tmpProductsList, sizeKey, sizeValue
    ).filter(function(product) {
      return !!product.onlineStoreUrl;
    });

    dropdownListObject.forEach(function(option) {
      if (option.tagKey === sizeKey ||
          option.tagKey === 'foam-comfort') return;

      var preferred = $options.find('li.dropdown_dec')
        .filter(function() {
          return $(this).data('title') === option.tagKey;
        })
        .find('ul li.active').data('val');

      if (typeof preferred === 'undefined') {
        preferred = currentProductMetafileds[option.tagKey];
      }

      var matches = prodListBasedOnSelection(
        candidates, option.tagKey, preferred
      );

      if (!matches.length) {
        matches = prodListBasedOnSelection(
          candidates, option.tagKey,
          currentProductMetafileds[option.tagKey]
        );
      }

      if (matches.length) candidates = matches;
    });

    if (!candidates.length) {
      $group.find('.frm_error')
        .text('This size is currently unavailable.').show();
      return;
    }

    var target = new URL(
      candidates[0].onlineStoreUrl, window.location.href
    );

    if (target.origin !== window.location.origin) return;

    if (target.pathname !== window.location.pathname) {
      window.location.assign(target.href);
    }

    return;
  }
  
  if($(this).parents("li.dropdown_dec").hasClass("foam_comfort_dropdown")){
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
    } 
    else {
      $(this).parents(".dropdown_hide").find("li").removeClass("active");
      $(this).addClass('active');
    }

    var foam_type = $(this).attr("data-val");
    var ship_day = $(".delivery-box.box-2").attr("addon-days");
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

    if($('form').find(".addon_days").attr("data-days") != "" && typeof ship_day != 'undefined'){
      var dayCount = parseInt(ship_day)
      
      if(foam_type.indexOf('Medium') < 0) {
        dayCount = parseInt(ship_day) + parseInt($('form').find(".addon_days").attr("data-days")); 
      }

      var newDate = new Date(new Date().getTime() + parseInt(dayCount)*24*60*60*1000);
      var delivery_date = newDate.getDate() +" "+ monthNames[newDate.getMonth()];

      $(".delivery-box.box-2 .text-wrp").find(".del-date").text(delivery_date);

      if(foam_type.indexOf('Medium') >= 0) {
        $(".delivery-box.box-1").show();
      }
      else{
        $(".delivery-box.box-1").hide();
      }
    }
  }
  else{
    $(this).parents("li.dropdown_dec").next('li').not(".foam_comfort_dropdown").find("ul li").removeClass("active");
    $(this).parents(".dropdown_hide").find("li").removeClass("active");
    $(this).addClass("active");
    $(this).parents(".var_dropdown").find('.dropdown_hide').eq(0).animate( { scrollLeft: '=0' }, 100);
  }

  $(this).parents("li.dropdown_dec").find(".frm_error").text("").hide();

  if($(this).parents('.size_dropdown,.seats_dropdown,.sizes_dropdown').length){
    if($(this).parents(".var_dropdown").find(".color_dropdown").length){
      $(this).parents(".var_dropdown").find(".cushion-type_dropdown").removeClass("animated");
      $(this).parents(".var_dropdown").find(".color_dropdown").addClass("animated");
    }
  }

  if($(this).parents('.color_dropdown').length){
    setTimeout(function() {
      if($("form").find(".var_dropdown .cushion-type_dropdown").find(".dropdown_hide li").length > 1){
        $("form").find(".var_dropdown").find(".color_dropdown").removeClass("animated");
        $("form").find(".var_dropdown").find(".cushion-type_dropdown").addClass("animated");
      }
      else{
        $("form").find(".var_dropdown").find(".cushion-type_dropdown").removeClass("animated");
      }
    }, 500);
  }
    
  var is_last = false;
  var total_len = $(this).parents(".var_dropdown").find("li.dropdown_dec").length-1;
  
  if($(this).parents(".var_dropdown").find("li.dropdown_dec").length == $(this).parents("li").index()){
   is_last = true;
  }
    
  $(this).parents("li.dropdown_dec").find(".dropdown_title span").text($(this).find("a").text());
  $(this).parents("li.dropdown_dec").find(".dropdown_title").removeClass("active_dropdown");
  
  var currentSelectbox = $(this).parents("li.dropdown_dec").data('title');
  var selectedValue = $(this).parents(".dropdown_hide").find("li.active").data("val");
  
  if(total_len == $(this).parents("li").index()){
   onChangeInitProductList(currentSelectbox, selectedValue, true, is_click="true", is_last=is_last, is_empty=total_len);
  }else{
   onChangeInitProductList(currentSelectbox, selectedValue, true, is_click="true", is_last=is_last, is_empty=0);
  }
  
  //onChangeInitProductList(currentSelectbox, selectedValue, true, is_click="true");
});


var interval;
interval = setInterval(function() { 
  var dropdown_obj = dropdownListObject[0].tagKey;
  var first_drop_obj = dropdown_obj+"_dropdown"
  
  if($(".foam_comfort_dropdown").length == 1 ){
    $("."+first_drop_obj).after($(".prod-foam-comfort").html());
    clearInterval(interval);
  }
}, 1000);

var preSelectvalue = function(sizeValue,foamValue, currentSelectbox){
  
  if(typeof foamValue !== "undefined"){
    
    var selectVal = sizeValue+" / "+foamValue;
    
    $("select.form_comfart_variants").val(selectVal).change();

    if(foamValue == "Medium Firm"){
      $(".addon_detail").hide();
    }
    else{
      $(".addon_detail").show();
    }

    var foamPrice = parseInt($("select.form_comfart_variants option[value='"+selectVal+"']").attr("data-price"));
    var total_price = parseInt(productPrice)+parseInt(foamPrice);

    $(".addon_detail").find(".addon_price").text(foamPrice/100);

    //change main product price
    if(!isNaN(total_price)) {
      $(".pro_main_prc .pro_details_li").find(".money").html(Shopify.formatMoney(total_price, $("body").attr("data-money-format")));
      $(".prod-stickybar .stpro-price").find(".money").html(Shopify.formatMoney(total_price, $("body").attr("data-money-format")));
    }
  }
  else{
    $(".addon_detail").hide();
    $(".pro_main_prc .pro_details_li").find(".money").html(Shopify.formatMoney(productPrice, $("body").attr("data-money-format")));
    $(".prod-stickybar .stpro-price").find(".money").html(Shopify.formatMoney(productPrice, $("body").attr("data-money-format")));
  }

  var mainProdprice = window.imbrox.foramConmfortInfo.mainProdPrice;
  // change price in foam comfort popup
  $(".pro-popup.foam-comfort li").find(".additional-price .m_price").html(mainProdprice);

  var foamProdInfo = window.imbrox.foramConmfortInfo.foramConmfortProd;
  // change price in foam comfort popup
  jQuery.each($(".pro-popup.foam-comfort li"), function(key,value ) {
    var foam_val = sizeValue+" / "+$(value).find("h4").text();
  
    jQuery.each(foamProdInfo, (f_key,f_value )=>{
      if(Object.keys(f_value)[0] == foam_val){
        var foam_price = Object.values(f_value)[0] / 100;
        $(this).find(".additional-price .addi_price").html(foam_price);
      }
    });
  });
}

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).on("click",".popup-sofasize",function(){
  $(".sofa-sizes").addClass("open");
  $("body").addClass("overflow-hidden");
});
  
$(document).on("click",".popup-foam-comfort",function(){
  $(".foam-comfort").addClass("open");
  $("body").addClass("overflow-hidden");
});

$(".pro-popup.sofa-sizes,.pro-popup.foam-comfort ").click(function(e){
  if(!e.target.closest(".popup-wrapper")) {
    if($(".pro-popup.sofa-sizes").hasClass("open")) {
      $(".pro-popup.sofa-sizes").removeClass("open");
    }
    if($(".pro-popup.foam-comfort").hasClass("open")) {
      $(".pro-popup.foam-comfort").removeClass("open");
    }
  }
});


// product color & cushion hover
$(document).ready(function () {
  /* Scroll to active option */
  var timeInter = setInterval(() => {
    if($(".var_dropdown").find(".dropdown_dec").length > 0){
      $(".var_dropdown").find(".dropdown_dec").each(function(index){
        if(index > 0){
          var offLeft = $(this).find(".dropdown_hide li.active").offset().left - 40;
          $(this).find('.dropdown_hide').animate({ scrollLeft: `+=${offLeft}px` }, 100);
        }
      });
      clearInterval(timeInter);
    }
  }, 100);
  
  
  setTimeout(function() {
    $(document).on({
      mouseenter: function () {
        const $span = $(this).find('.img-hover');
        const rect = this.getBoundingClientRect();
        $span.css({
          position: 'fixed',
          top: rect.top,
          left: rect.right, 
          display: 'block' 
        });
      },
      mouseleave: function () {
        const $span = $(this).find('.img-hover');
        $span.css({
          position: '',
          top: '',
          left: '',
          display: 'none' 
        });
      }
    }, ".cushion-type_dropdown .dropdown_hide li,.color_dropdown .dropdown_hide li");
  }, 1500);
});

